import {
  tagV2,
  snoozeV2,
  message,
  teammates,
  box,
} from 'assets/icons/groove/v2'

const isOrIsNotOperators = [
  {
    name: 'is',
    value: 'is',
  },
  {
    name: 'is not',
    value: 'is_not',
  },
]

const containDoNotContainOperators = [
  {
    name: 'contain',
    value: 'contain',
  },
  {
    name: 'do not contain',
    value: 'do_not_contain',
  },
]

const containsDoesNotContainOperators = [
  {
    name: 'contains',
    value: 'contains',
  },
  {
    name: 'does not contain',
    value: 'does_not_contain',
  },
]

const startsWithEndsWithOperators = [
  {
    name: 'starts with',
    value: 'starts_with',
  },
  {
    name: 'ends with',
    value: 'ends_with',
  },
]

const matchesOperator = [
  {
    name: 'matches',
    value: 'matches',
  },
]

const domainOperators = [
  {
    name: 'domain is',
    value: 'domain_is',
  },
  {
    name: 'domain is not',
    value: 'domain_is_not',
  },
]

const textAndPartialTextOperators = [
  ...isOrIsNotOperators,
  ...containsDoesNotContainOperators,
  ...startsWithEndsWithOperators,
  ...matchesOperator,
]

const textAndDomainOperators = [
  ...domainOperators,
  ...isOrIsNotOperators,
  ...containsDoesNotContainOperators,
  ...startsWithEndsWithOperators,
  ...matchesOperator,
]

const contactNameOperators = [
  ...isOrIsNotOperators,
  ...containsDoesNotContainOperators,
  ...startsWithEndsWithOperators,
]

const numberOperators = [
  ...isOrIsNotOperators,
  {
    name: 'less than',
    value: 'lt',
  },
  {
    name: 'less than or equal',
    value: 'lteq',
  },
  {
    name: 'greater than',
    value: 'gt',
  },
  {
    name: 'greater than or equal',
    value: 'gteq',
  },
]

const tagsOperators = [...containDoNotContainOperators]

export const ruleConditions = {
  parameters: [
    {
      name: 'To email',
      value: 'to_email',
    },
    {
      name: 'From email',
      value: 'from_email',
    },
    {
      name: 'CC field',
      value: 'cc',
    },
    {
      name: 'Bcc field',
      value: 'bcc',
    },
    {
      name: 'Subject',
      value: 'subject',
    },
    {
      name: 'Description',
      value: 'description',
    },
    {
      name: 'Agent reply count',
      value: 'agent_message_count',
    },
    {
      name: 'Customer reply count',
      value: 'enduser_message_count',
    },
    {
      name: 'Total message count',
      value: 'comments_count',
    },
    {
      name: 'Subject or description',
      value: 'subject_or_description',
    },
    {
      name: 'Contact name',
      value: 'contact_name',
    },
    {
      name: 'Tags',
      value: 'labels',
    },
    {
      name: app.t('Mailbox'),
      value: 'mailbox',
    },
    {
      name: 'Channel',
      value: 'channel',
      deprecated: true,
    },
    {
      name: 'Status',
      value: 'status',
    },
    {
      name: 'Priority',
      value: 'priority',
      deprecated: true,
    },
  ],
  param_operators: {
    to_email: textAndDomainOperators,
    from_email: textAndDomainOperators,
    cc: textAndDomainOperators,
    bcc: textAndDomainOperators,
    subject: textAndPartialTextOperators,
    description: textAndPartialTextOperators,
    subject_or_description: textAndPartialTextOperators,
    contact_name: contactNameOperators,
    labels: tagsOperators,
    mailbox: isOrIsNotOperators,
    channel: isOrIsNotOperators,
    status: numberOperators,
    priority: numberOperators,
    enduser_message_count: numberOperators,
    agent_message_count: numberOperators,
    comments_count: numberOperators,
  },
  values: {
    to_email: '',
    from_email: '',
    subject: '',
    description: '',
    subject_or_description: '',
    add_note: '',
    contact_name: '',
    labels: '',
    priority: [
      {
        name: 'Low',
        value: 'low',
      },
      {
        name: 'Medium',
        value: 'medium',
      },
      {
        name: 'High',
        value: 'high',
      },
      {
        name: 'Urgent',
        value: 'urgent',
      },
    ],
    status: [
      {
        name: 'Unread',
        value: 'unread',
        disabled: false,
      },
      {
        name: 'Opened',
        value: 'opened',
        disabled: false,
      },
      {
        name: 'Closed',
        value: 'closed',
        disabled: false,
      },
      {
        name: 'Spam',
        value: 'spam',
        disabled: false,
      },
    ],
    channel: [
      {
        name: 'Widget',
        value: 'Widget',
      },
      {
        name: 'Facebook',
        value: 'Facebook',
      },
      {
        name: 'Twitter',
        value: 'Twitter',
      },
      {
        name: 'Chat',
        value: 'Chat',
      },
      {
        name: 'Email',
        value: 'Email',
      },
    ],
    mailbox: { valueType: 'Mailbox' },
  },
}

const ruleActions = isPaidAccount => {
  const parameters = [
    {
      name: 'Set Priority as',
      value: 'priority',
      deprecated: true,
    },
    {
      name: 'Set Starred as',
      value: 'star',
    },
    {
      name: 'Set State as',
      value: 'status',
    },
    {
      name: `Set ${app.t('Mailbox')}`,
      value: 'mailbox',
    },
    {
      name: `Assign to ${app.t('Agent')}`,
      value: 'assignee_id',
    },
    {
      name: `Assign to Available ${app.t('Agent')}`,
      value: 'next_available_agent',
    },
    {
      name: `Assign to ${app.t('Group')}`,
      value: 'assignee_group_id',
    },
    {
      name: `Assign to Available ${app.t('Agent')} in ${app.t('Group')}`,
      value: 'next_available_agent_in_group',
    },
    {
      name: 'Unassign',
      value: 'unassign',
    },
    {
      name: 'Add tag',
      value: 'label',
    },
    {
      name: 'Remove tag',
      value: 'remove_label',
    },
    {
      name: 'Clear all tags',
      value: 'remove_all_labels',
    },
    {
      name: 'Set Snooze',
      value: 'snooze_until',
    },
    {
      name: 'Unsnooze',
      value: 'unsnooze',
    },
    {
      name: 'Add Follower',
      value: 'add_agent_as_follower',
    },
    {
      name: 'Reply to conversation',
      value: 'send_email_reply',
    },
    {
      name: 'Add Note',
      value: 'add_note',
    },
    {
      name: 'Forward a conversation',
      value: 'forward_conversation',
    },
  ]

  if (isPaidAccount) {
    parameters.push({
      name: `Send Email to ${app.t('Agent')}`,
      value: 'send_email_to_agent',
    })

    parameters.push({
      name: 'Send Email to Customer',
      value: 'send_email_to_requester',
    })
  }

  const values = {
    star: {
      dataType: 'LIST',
      options: [
        {
          name: 'True',
          value: '4000',
        },
        {
          name: 'False',
          value: '1000',
        },
      ],
    },
    priority: {
      dataType: 'LIST',
      options: [
        {
          name: 'Low',
          value: '1000',
        },
        {
          name: 'Medium',
          value: '2000',
        },
        {
          name: 'High',
          value: '3000',
        },
        {
          name: 'Urgent',
          value: '4000',
        },
      ],
    },
    subject: { dataType: 'TEXT' },
    subject_or_description: { dataType: 'TEXT' },
    label: { dataType: 'TAGS', paramType: 'name' },
    remove_label: { dataType: 'TAGS', paramType: 'id' },
    remove_all_labels: { dataType: null },
    next_available_agent: { dataType: null },
    unassign: { dataType: null },
    status: {
      dataType: 'LIST',
      options: [
        {
          name: 'Opened',
          value: 'opened',
          disabled: false,
        },
        {
          name: 'Closed',
          value: 'closed',
          disabled: false,
        },
        {
          name: 'Spam',
          value: 'spam',
          disabled: false,
        },
      ],
    },
    channel: {
      dataType: 'LIST',
      options: [
        {
          name: 'Widget',
          value: 'Widget',
        },
        {
          name: 'Facebook',
          value: 'Facebook',
        },
        {
          name: 'Twitter',
          value: 'Twitter',
        },
        {
          name: 'Chat',
          value: 'Chat',
        },
        {
          name: 'Email',
          value: 'Email',
        },
      ],
    },
    snooze_until: {
      dataType: 'LIST',
      options: [
        {
          name: '4 hours',
          value: '14400',
        },
        {
          name: '2 days',
          value: '172800',
        },
        {
          name: '4 days',
          value: '345600',
        },
        {
          name: '1 week',
          value: '604800',
        },
        {
          name: '2 weeks',
          value: '1209600',
        },
        {
          name: '1 month',
          value: '2592000',
        },
        {
          name: 'Indefinitely',
          value: 'indefinitely',
        },
      ],
    },
    unsnooze: { dataType: null },
    mailbox: { dataType: 'LIST', valueType: 'Mailbox' },
    assignee_id: { dataType: 'LIST', valueType: 'Agent' },
    assignee_group_id: { dataType: 'LIST', valueType: 'Group' },
    next_available_agent_in_group: { dataType: 'LIST', valueType: 'Group' },
    add_agent_as_follower: { dataType: 'LIST', valueType: 'Agent' },
    send_email_to_agent: { dataType: 'MessageTemplate', valueType: 'Agent' },
    send_email_to_requester: { dataType: 'MessageTemplate' },
    send_email_reply: { dataType: 'MessageTemplate', valueType: 'ReplyAgent' },
    add_note: { dataType: 'NOTE', valueType: 'ReplyAgent' },
    forward_conversation: { dataType: 'EMAIL' },
  }

  return {
    parameters,
    values,
  }
}

export const ruleActionsForPaid = {
  ...ruleActions(true),
}

export const ruleActionsForUnpaid = {
  ...ruleActions(false),
}

export const ruleTriggersParemetersSectionTitles = {
  message: {
    title: 'Message triggers',
    icon: message,
  },
  conversationStatus: {
    title: 'State changes',
    icon: box,
  },
  teammate: {
    title: 'Teammates',
    icon: teammates,
  },
  snooze: {
    title: 'Snooze',
    icon: snoozeV2,
  },
  tag: {
    title: 'Tags',
    icon: tagV2,
  },
}

export const ruleTriggers = {
  parameters: {
    message: [
      {
        name: 'New conversation is received',
        value: 'created',
      },
      {
        name: 'Inbound message received',
        value: 'new_inbound_message',
      },
      {
        name: 'Outbound message sent',
        value: 'new_outbound_message',
      },
      {
        name: `New conversation is created by ${app.t('agent')}`,
        value: 'created_by_agent',
      },
      {
        name: `Conversation moves to ${app.t('mailbox')}`,
        value: 'mailbox_changed',
      },
      {
        name: 'Conversation is rated',
        value: 'conversation_rated',
        inputType: 'rating',
      },
      {
        name: 'Any update occurs on a conversation',
        value: 'updated',
        tooltip:
          'This will trigger the rule when anything happens on the conversation.',
      },
    ],
    conversationStatus: [
      {
        name: 'Conversation changes to Closed',
        value: 'conversation_closed',
      },
      { name: 'Conversation is Reopened', value: 'conversation_opened' },
      {
        name: 'Conversation is sent to Trash',
        value: 'conversation_trashed',
      },
      {
        name: 'Conversation is sent to Spam',
        value: 'conversation_spammed',
      },
      {
        name: 'Conversation is restored from Trash',
        value: 'conversation_untrashed',
      },
    ],
    teammate: [
      {
        name: `${app.t('Agent')} is mentioned`,
        value: 'agent_mentioned',
        inputType: 'teammate',
      },
      {
        name: `${app.t('Agent')} is assigned`,
        value: 'agent_assigned',
        inputType: 'teammate',
      },
      {
        name: `${app.t('Agent')} is unassigned`,
        value: 'agent_unassigned',
        inputType: 'teammate',
      },
      {
        name: 'New note is added by...',
        value: 'new_note',
        inputType: 'teammate',
      },
    ],
    snooze: [
      { name: 'Conversation Snoozed', value: 'conversation_snoozed' },
      {
        name: 'Conversation Snooze expires',
        value: 'conversation_automatic_unsnoozed',
      },
    ],
    tag: [
      { name: 'Tag is added', value: 'label_added', inputType: 'tag' },
      { name: 'Tag is removed', value: 'label_removed', inputType: 'tag' },
    ],
  },
}

export const ruleTriggersBySettingInputNeeded = Object.fromEntries(
  Object.values(ruleTriggers.parameters)
    .flat(1)
    .map(obj => [obj.value, obj.inputType !== undefined])
)
